"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAllQuestions = void 0;
const getAllQuestions = (parentNode, array = []) => {
    var _a;
    if (!parentNode.root && parentNode.title)
        array.push(parentNode);
    for (let i = 0; i < ((_a = parentNode.subQuestions) === null || _a === void 0 ? void 0 : _a.length); i++) {
        const sq = parentNode.subQuestions[i];
        (0, exports.getAllQuestions)(sq, array);
    }
    return array;
};
exports.getAllQuestions = getAllQuestions;
exports.default = exports.getAllQuestions;
